import { render, staticRenderFns } from "./nlpRules.vue?vue&type=template&id=6521b74d"
import script from "./nlpRules.vue?vue&type=script&lang=js"
export * from "./nlpRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports